import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function PrivacyPolicy() {
    return (
        <div className={styles.page}>
            <div className={styles.wrap}>
                <h1 className={styles.title}>Политика обработки персональных данных</h1>
                <button
                    className={styles.back}
                    onClick={() => (window.location.href = "/")}
                >
                    ← На главную
                </button>

                <article className={styles.sheet}>
                <div className={styles.card}>
                    <p className={styles.text}>
                        Дата вступления в силу: 29 сентября 2025 г. — последняя редакция.
                    </p>
                </div>

                {/* 1 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>1. Общие положения</h2>

                    <p className={styles.text}>
                        1.1. Настоящая Политика обработки персональных данных (далее — «Политика») определяет порядок
                        обработки и защиты персональных данных пользователей веб-сайта https://aimir.tech
                        (далее — «Сайт» и «Сервис») Индивидуальным предпринимателем СЛЕШИНЫМ АЛЕКСЕЕМ КИРИЛЛОВИЧЕМ
                        (далее — «Оператор»).
                    </p>

                    <p className={styles.text}>
                        1.2. Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ
                        «О персональных данных».
                    </p>

                    <p className={styles.text}>
                        1.3. Целью Политики является обеспечение защиты прав и свобод человека и гражданина при
                        обработке его персональных данных, включая защиту прав на неприкосновенность частной жизни,
                        личную и семейную тайну.
                    </p>

                    <p className={styles.text}>
                        1.4. Используя Сайт и Сервис, Пользователь выражает согласие с условиями настоящей Политики.
                    </p>
                </section>

                {/* 2 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>2. Какие персональные данные мы обрабатываем</h2>

                    <p className={styles.text}>
                        Данные для регистрации: e-mail, имя (или псевдоним), хэшированный пароль.<br />
                        При привязке Telegram в профиле: Telegram User ID.<br />
                        Автоматически собираемые данные: IP-адрес, данные о браузере и устройстве, cookies,
                        история действий на Сайте.<br />
                        Добровольно предоставляемые данные: тексты, документы и иной Контент, загружаемые для проверки.
                        Оператор не осуществляет целенаправленную обработку специальных категорий персональных данных;
                        обработка Контента происходит автоматически исключительно для оказания Услуги и не сохраняется
                        дольше, чем требуется для формирования отчёта.
                    </p>
                </section>

                {/* 3 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>3. Цели обработки персональных данных</h2>

                    <p className={styles.text}>
                        Заключение и исполнение договора (Публичной оферты).<br />
                        Идентификация Пользователя.<br />
                        Предоставление персонализированных функций.<br />
                        Связь: уведомления, ответы, поддержка.<br />
                        Анализ и улучшение работы Сервиса.<br />
                        Информирование о тарифах, акциях и обновлениях (при согласии).<br />
                        Обеспечение безопасности и предотвращение мошенничества.
                    </p>
                </section>

                {/* 4 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>4. Правовые основания обработки</h2>

                    <p className={styles.text}>
                        Согласие субъекта персональных данных (ст. 6 ФЗ № 152-ФЗ).<br />
                        Необходимость для заключения и исполнения договора.
                    </p>
                </section>

                {/* 5 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>5. Способы и сроки обработки</h2>

                    <p className={styles.text}>
                        Обработка осуществляется автоматизированным и неавтоматизированным способами.<br />
                        Персональные данные хранятся столько, сколько необходимо для достижения целей обработки.<br />
                        Данные учётной записи — весь срок действия аккаунта.<br />
                        Контент и результаты проверки — 24 часа, затем удаляются автоматически.<br />
                        По истечении сроков хранения данные уничтожаются или обезличиваются.
                    </p>
                </section>

                {/* 6 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>6. Меры по защите данных</h2>

                    <p className={styles.text}>
                        Шифрование при передаче (SSL/TLS).<br />
                        Регулярное резервное копирование.<br />
                        Разграничение доступа внутри компании.<br />
                        Антивирусная защита и системы обнаружения вторжений.
                    </p>
                </section>

                {/* 7 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>7. Передача третьим лицам</h2>

                    <p className={styles.text}>
                        Использование API сторонних ИИ-сервисов (OpenAI, Yandex GPT и др.).<br />
                        Передача по требованиям госорганов.
                    </p>
                </section>

                {/* 8 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>8. Права субъекта персональных данных</h2>

                    <p className={styles.text}>
                        Доступ, уточнение, блокирование, уничтожение данных.<br />
                        Отзыв согласия — запрос на e-mail: strong.2026@list.ru (удаление до 30 дней).<br />
                        Требование устранения нарушений.<br />
                        Обжалование действий Оператора в Роскомнадзор.
                    </p>
                </section>

                {/* 9 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>9. Заключительные положения</h2>

                    <p className={styles.text}>
                        Оператор вправе изменять Политику; новая редакция вступает в силу с момента размещения.
                        Предложения и вопросы — на e-mail: strong.2026@list.ru.<br />
                        Актуальная версия: /privacy-policy.
                    </p>

                    <h3 className={styles.h3}>Реквизиты Оператора</h3>

                    <p className={styles.text}>
                        Индивидуальный предприниматель: СЛЕШИН АЛЕКСЕЙ КИРИЛЛОВИЧ<br />
                        Юридический адрес: 125171, Россия, г. Москва, проезд 5-й Войковский, д. 2, кв. 37<br />
                        ИНН: 774335676546<br />
                        ОГРНИП: 324774600362542<br />
                        E-mail: strong.2026@list.ru<br />
                        Телефон: 8 (995) 300-38-86
                    </p>

                    <p className={styles.update}>Последнее обновление: 29.09.2025</p>
                </section>
                </article>
            </div>
        </div>
    );
}
